import React from 'react';
import Hero from './components/sections/Hero';
import Stats from './components/sections/Stats';
import GoogleReviews from './components/sections/GoogleReviews';
import Videos from './components/sections/Videos';
import Banner from './components/sections/Banner';
import Cases from './components/sections/Cases';
import Gallery from './components/sections/Gallery';
import Founder from './components/sections/Founder';
import CTA from './components/sections/CTA';
import Footer from './components/sections/Footer';
import WhatsAppButton from './components/floating/WhatsAppButton';
import './styles/global.css';

function App() {
  return (
    <div className="app">
      <Hero />
      <Stats />
      <GoogleReviews />
      <Videos />
      <Banner />
      <Cases />
      <Gallery />
      <Founder />
      <CTA />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
